import { useEffect } from 'react'
import loadHubSpotFormsScript from 'lib/loadHubSpotFormsScript'

// HubSpotフォーム生成（必要なページでのみ forms embed を読み込む）
const useHubSpotGenerate = (regionData: string, portalIdData: string, formIdData: string, targetData: string) => {
  useEffect(() => {
    let cancelled = false

    const timer = window.setTimeout(() => {
      loadHubSpotFormsScript()
        .then(() => {
          if (cancelled || !window.hbspt?.forms?.create) {
            return
          }
          window.hbspt.forms.create({
            region: regionData,
            portalId: portalIdData,
            formId: formIdData,
            target: targetData,
          })
        })
        .catch(() => {
          // スクリプト読み込み失敗時はフォームを生成しない
        })
    }, 100)

    return () => {
      cancelled = true
      window.clearTimeout(timer)
    }
  }, [regionData, portalIdData, formIdData, targetData])

  return <></>
}

export default useHubSpotGenerate
